export function getHouseContent(playerName, apiaryName) {
  const grandpaGreetings = [
    `${playerName}, my favorite sonofab, oh sorry, almost had to put another one in the swear jar. What's up?`,
    `Don't bother me right now!`,
    `My Damned Back Hurts. What?`,
    `What can I help you with, kid?`,
    `Did you know they traded McCarty? He's a HERO!`,
    `Did you know I didn't know your Grandma's name when we conceived your mother? Yup. That's why your mother's name is Hennessy.`,
    `${playerName} How the hell are ya?`,
    `The problem wasn't Mitchell, Peete, Kramer or even the defense. It was the OWNERSHIP!`,
    `You see, ${playerName}, at the beginning of the universe there was a minute amount more matter than antimatter, why that was the case, we don't really know.`,
    `Neutron stars are the remnants of massiva stars that ended their life in SUPERNOVAE! The remaining matter falls into a state so dense that a teaspoon weighs 10 MILLION TONS!`,
    `Crows and ravens are probably the smartest non human animals on earth! Their problem solving skills, memory and language are mind blowing! Google 'crow turns on tap'`,
    `The Ancient Greeks were crazy smart. They invented calculus, geometry, and even measured the radius of the earth using shadows!`,
    `Don't cut those weeds out back, those are mine.`,
    `If you find mushrooms out there I claim ownership of half.`,
    `I just got up to do something and I can't remember what it was.`,
    `If I am on a train traveling toward you, and a lightning bolt hits halfway between us, I will record the lightning as striking before you say it strikes. This is because of our different frames of reference. THIS IS RELATIVITY!`,
    `Clocks on spaceships in orbit, like the ISS, tick slower than they do on earth. THIS IS RELATIVITY!`,
    `Did you know that chickadees can remember the location of thousands of cached foodstuffs?!`,
    `Players these days would quit if they had to play the Bad Boys!`,
    `All atoms heavier than hydrogen were forged in the cores of stars! Elements heavier than iron were forged in SUPERNOVAE!`,
    `When I was a kid we'd sneek into the games. Run right past the security and into the bleachers.`,
    `Gravity doesn't really 'pull' things, in reality, heavy things distort spacetime, and objects falling toward those heavier items are just falling through the curved SPACETIME! THIS IS RELATIVITY!`,
    `What?!`,
    `You know what, kid, I really love having you around. What's up?`,
    `The only undebatable GOAT that I can think of is Gretzky. Lemieux woulda been in the conversation though...`,
    `If I was falling into a black hole, and you were watching from a distance, I would stop at the event horizon and NEVER MOVE. From my perspective I got ripped apart in a process called spaghettification and then accreted into the singularity. THIS IS RELATIVITY!`,
    `What the hell was I just going to do?`,
    `WHO HAS DISTURBED MY SLUMBER?`,
    `You said what what?`,
    `Everything was imported from Mexico when I was a kid! It was brown and shaped like a brick!`,
    `Did you know that the AMERICAN Government once tested the weaponization of ticks and fleas with deadly communicable diseases?!`,
    `Cabrera was the greatest clutch hitter of all time, but if I'm going pure, I'm going with Gwynn.`,
    `If it's the cops I'm not here`,
    `Frogs use blood sugar to act as antifreeze, preventing ice build up in their vital organs during winter. This allows them to practically get FROZEN SOLID and still wake up in the Spring!`,
    `Did you know that honey bees go through stages in their lives? They start off as nurse bees, doing house work, then graduate to foraging duty!`,
    `Queen bees mate on mating flights with between 10 and 20 drones!`,
    `As a bee colony builds up, they usually want to swarm. This is their evolutionary goal. Our goal as beekeepers is to keep them from doing that by splitting them and adding room so they don't get cramped!`,
    `Did you know a brilliant lady named Henrietta was hired by Harvard to work as a computer, doing mundane tasks over and over. She used the data she was given to figure out a new way to measure the distances to stars!`,
    `Say we had two twins, and sent one on a spaceship at nearly the speed of light on a trip around our solar system. When they returned, they would be CONSIDERABLY younger than their twin! THIS IS RELATIVITY!`,
    `When a bee colony reaches their swarm threshold, they start building queen cells. The amount of queen cells is dependent upon the amount of bees and brood. Just before those cells emerge, a large portion of the bees will leave in a swarm with the old queen!`,
    `Beekeeping used to be just about swarm management. Add boxes and collect honey. Those were the good old days. Damned mites.`,
    `When you see queen cells hanging off of the bottoms of the frames, you know something's up. Something's gonna go down`,
    `It's all about the queens, ${playerName}! Find the good ones, find the ones that do what you want, and split 'em!`,
    `When I was a kid you had to know a guy.`,
    `My whole method can be summed up like this. Split 'em, add boxes until September. Harvest. But ya gotta feed 'em if they need it. Even the best bees will take a fine bit of stores to get through the cold!`,
    `There's nothing wrong with feeding granulated sugar! People think you're stealing from 'em but when it comes to winter survival what they really need is carbs. Good clean carbs.`,
    `When the honey's flowin, you'll know.`,
    `Just when you think you got a good idea at what those bees are up to, you see 'em in the trees.`,
    `Did you just hear that fart?`,
    `I always said, split 'em thin in the spring!`,
    `When in doubt, add the box, ${playerName}`,
    `Queen cells can be the end of you or your ticket to bigger numbers. It's up to you. But you gotta stay on top of 'em. You gotta stay on top of 'em`,
    `Did you know that as a honey bee develops it goes through stages, from egg to larva, pupa and then it emerges as a bee! This process takes 21 days for workers and just 16 for the queen!`,
  ];

  const houseIntro = [
    {
      action: "dialog",
      content: [
        `I'm so glad to have you, ${apiaryName} is in trouble and I can't think of anyone I would rather have help me bring it back`,
      ],
    },
    {
      action: "dialog",
      content: [
        `It's those DAMNED mites, ${playerName}, they build up in the hives, sucking the lifeblood and spreading disease!`,
      ],
    },
    { action: "move", content: 20, direction: "right" },
    {
      action: "dialog",
      content: [
        `They came to this area 30 years ago, we didn't know what to think!`,
      ],
    },
    {
      action: "dialog",
      content: [
        `They aren't like other parasites, our bees don't seem to have much of a defense for them!`,
      ],
    },
    { action: "move", content: 20, direction: "left" },
    {
      action: "dialog",
      content: [
        `So, our great ${apiaryName} dwindled over time, succumbing to those friggin' bastard mites!`,
      ],
    },
    {
      action: "dialog",
      content: [`UGH! Just talking about those damned things makes me livid!`],
    },
    { action: "move", content: 20, direction: "right" },
    {
      action: "dialog",
      content: [
        `So please, ${playerName}, help me rebuild ${apiaryName}. We only have $2000, but I am sure you can figure out a way to rebuild.`,
      ],
    },

    { action: "move", content: 20, direction: "left" },
    {
      action: "dialog",
      content: [
        `To learn about beekeeping, head to the bee club in town. There are tons of knowledgeable people there.`,
      ],
    },
    {
      action: "dialog",
      content: [
        `To purchase bees and other items, either use the computer in your room, or head to town. To access the inventory, press I. To add hives or interact with items, use the SPACE bar.`,
      ],
    },
    {
      action: "dialog",
      content: [
        `And lastly, kiddo, I want to give you my smoker! She's seen better days, but she works! You had better get out there and check on those bees!`,
      ],
    },
  ];

  return {
    getHouseIntro: () => {
      return houseIntro;
    },
    getGrandpaGreetings: () => {
      return grandpaGreetings;
    },
  };
}
